import { FIND_TRANSACTION_REPORT } from "../../routes";
import customAxios from "../../customAxios";
import { IFindDriverTransactions } from "../../../types/common.interface";

async function findDriverTransaction(props: IFindDriverTransactions): Promise<any> {

  let thisUrl: string = FIND_TRANSACTION_REPORT;

  let body: any = {page: props?.page, limit: props?.limit};

  if (props.startAt) {
    body = {
      ...body,
      filter: {
        ...body?.filter,
        startAt: new Date(props.startAt).toISOString().split("T")[0] + "T00:00:00.0Z",
      },
    };
  }
  if (props.endAt) {
    body = {
      ...body,
      filter: {
        ...body?.filter,
        endAt: new Date(props.endAt).toISOString().split("T")[0] + "T00:00:00.0Z",
      },
    };
  }
  if (props?.filter?.company) {body = {...body, filter: {...body?.filter, company: props?.filter?.company}}}
  if (props?.filter?.city   ) {body = {...body, filter: {...body?.filter, city   : props?.filter?.city   }}}

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        path : props?.search?.path ,
        base : props?.search?.base ,
        value: props?.search?.value,
      },
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findDriverTransaction;
